// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Inputs-FileUpload-styles___fileContainer--_1dPr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px;
  padding-left: 24px;
  padding-right: 24px;
}

.components-Inputs-FileUpload-styles___fileNameContainer--XFuqI {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto-Medium', 'Roboto';
  font-weight: 600;
}

.components-Inputs-FileUpload-styles___fileCheckIcon--sbcjJ {
  font-family: 'Roboto-Medium', 'Roboto';
  font-size: 15px;
  letter-spacing: 0;
  text-align: center;
  margin-right: 8px;
}

.components-Inputs-FileUpload-styles___changeFile--YBsi8 {
  font-family: 'Roboto-Medium', 'Roboto';
  font-size: 15px;
  color: #318afb;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
}

.components-Inputs-FileUpload-styles___errorMessage--R25tu {
  font-size: 12px;
  text-align: left;
  color: #ff0000;
}

.components-Inputs-FileUpload-styles___errorFileName--p6kyI {
  border-bottom: 1px solid #ff0000;
}

.components-Inputs-FileUpload-styles___importEmployees--EbS8S {
  border-radius: 6px;
  display: flex;
  justify-content: center;
  height: 71px;
  border: 1px dashed #e0e2e6;
  align-items: center;
  cursor: pointer;
}

.components-Inputs-FileUpload-styles___importEmployees--EbS8S svg {
    margin-right: 8px;
  }

.components-Inputs-FileUpload-styles___importEmployees--EbS8S span {
    cursor: pointer;
    color: #318afb;
    font-size: 17px;
    font-family: Roboto;
    letter-spacing: 0;
    font-family: 'Roboto-Medium', 'Roboto';
  }`, "",{"version":3,"sources":["webpack://./components/Inputs/FileUpload/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AAcjB;;AAZE;IACE,iBAAiB;EACnB;;AAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,sCAAsC;EACxC","sourcesContent":[".fileContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 12px;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.fileNameContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto-Medium', 'Roboto';\n  font-weight: 600;\n}\n\n.fileCheckIcon {\n  font-family: 'Roboto-Medium', 'Roboto';\n  font-size: 15px;\n  letter-spacing: 0;\n  text-align: center;\n  margin-right: 8px;\n}\n\n.changeFile {\n  font-family: 'Roboto-Medium', 'Roboto';\n  font-size: 15px;\n  color: #318afb;\n  letter-spacing: 0;\n  text-align: center;\n  font-weight: 600;\n}\n\n.errorMessage {\n  font-size: 12px;\n  text-align: left;\n  color: #ff0000;\n}\n\n.errorFileName {\n  border-bottom: 1px solid #ff0000;\n}\n\n.importEmployees {\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  height: 71px;\n  border: 1px dashed #e0e2e6;\n  align-items: center;\n  cursor: pointer;\n\n  svg {\n    margin-right: 8px;\n  }\n\n  span {\n    cursor: pointer;\n    color: #318afb;\n    font-size: 17px;\n    font-family: Roboto;\n    letter-spacing: 0;\n    font-family: 'Roboto-Medium', 'Roboto';\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fileContainer": `components-Inputs-FileUpload-styles___fileContainer--_1dPr`,
	"fileNameContainer": `components-Inputs-FileUpload-styles___fileNameContainer--XFuqI`,
	"fileCheckIcon": `components-Inputs-FileUpload-styles___fileCheckIcon--sbcjJ`,
	"changeFile": `components-Inputs-FileUpload-styles___changeFile--YBsi8`,
	"errorMessage": `components-Inputs-FileUpload-styles___errorMessage--R25tu`,
	"errorFileName": `components-Inputs-FileUpload-styles___errorFileName--p6kyI`,
	"importEmployees": `components-Inputs-FileUpload-styles___importEmployees--EbS8S`
};
module.exports = ___CSS_LOADER_EXPORT___;
